import { cn } from "@/lib/utils";

export type TileStatus = "empty" | "pending" | "correct" | "present" | "absent";

interface TileProps {
  char?: string;
  status: TileStatus;
  className?: string;
  delay?: number;
  isHinted?: boolean;
}

export function Tile({ char = "", status, className, delay = 0, isHinted = false }: TileProps) {
  const baseClasses = "w-[62px] h-[62px] sm:w-[66px] sm:h-[66px] md:landscape:w-[62px] md:landscape:h-[62px] border-2 rounded flex items-center justify-center text-2xl sm:text-[28px] font-bold uppercase transition-all duration-700 ease-out";
  
  const statusClasses = {
    empty: "bg-tile-empty border-tile-empty-border text-foreground",
    pending: "bg-tile-pending border-tile-pending-border text-foreground animate-tile-pop",
    correct: "bg-tile-correct border-tile-correct text-tile-correct-foreground animate-tile-flip",
    present: "bg-tile-present border-tile-present text-tile-present-foreground animate-tile-flip", 
    absent: "bg-tile-absent border-tile-absent text-tile-absent-foreground animate-tile-flip"
  };

  const shouldAnimate = status === "correct" || status === "present" || status === "absent";
  
  // Visual indicator for hint-revealed positions (only on empty tiles in current row)
  const hintedClasses = isHinted && status === "empty" 
    ? "ring-2 ring-tile-present/60 animate-pulse shadow-[0_0_8px_hsl(var(--tile-present)/0.4)]" 
    : "";

  return (
    <div 
      className={cn(baseClasses, statusClasses[status], hintedClasses, className)}
      style={shouldAnimate ? { animationDelay: `${delay}ms` } : undefined}
      data-game-tile="true"
      data-hinted={isHinted ? "true" : undefined}
    >
      {char}
    </div>
  );
}